export default __webpack_public_path__ + "static/media/close_ply.407194d4.svg";